/** Registry of every locale's dictionary, keyed by locale code. */
import type { Locale } from "./config";
import type { Dictionary } from "./types";
import { en } from "./locales/en";
import { zh } from "./locales/zh";
import { es } from "./locales/es";

export const dictionaries: Record<Locale, Dictionary> = { en, zh, es };
